// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CiCircleFilledSvg from "@fishx/icons-svg/es/asn/CiCircleFilled";
import FishxIcon from '../components/FishxIcon';

var CiCircleFilled = function CiCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CiCircleFilledSvg
  }));
};

CiCircleFilled.displayName = 'CiCircleFilled';
export default React.forwardRef(CiCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CiCircleFilled.js
// module id = 2205
// module chunks = 0